import { render, staticRenderFns } from "./social-help-request.vue?vue&type=template&id=05f2e79c"
import script from "./social-help-request.vue?vue&type=script&lang=js"
export * from "./social-help-request.vue?vue&type=script&lang=js"
import style0 from "./social-help-request.vue?vue&type=style&index=0&id=05f2e79c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports